<template>

</template>

<script>

  var bookrackList = JSON.parse(localStorage.getItem('books'));

  export default {
    name: 'hello',
    bookrackList
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// GlobalValue.vue?4350eaae